import styled from "@emotion/styled";
// eslint-disable-next-line no-empty-pattern
export const TelLink = styled("a")(({}) => ({
  textDecoration: "none",
  fontSize: "1rem",
  fontWeight: "bold",
  color: "inherit",
}));
// eslint-disable-next-line no-empty-pattern
export const ServicesList = styled("ul")(({}) => ({}));
// eslint-disable-next-line no-empty-pattern
export const ServicesListItem = styled("li")(({}) => ({
  listStyle: "square",
}));
